import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RotaDetalhesRelatorioVO } from '~model/vo/RelatorioTabelaVO';

@Component({
    selector: 'app-relatorio-dinamico-xls-dialog',
    template: '<app-relatorio-dinamico-xls [resumo]="data"></app-relatorio-dinamico-xls>',
})
export class RelatoriDinamicoXlsDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: RotaDetalhesRelatorioVO) {
    }
}
